var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _rect3, _rect4, _path9, _path10, _polygon, _path11, _path12, _path13, _path14, _path15, _path16, _line, _path17, _rect5, _rect6, _text, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj75(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aae2c2;}.cls-2{fill:#50bd86;}.cls-3{fill:#434341;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#ffdc00;}.cls-6{font-size:45px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.12,65.88l-19.74,4a.76.76,0,0,0-.65.65l-3.18,19.67a.78.78,0,0,1-1.53,0l-4.17-19.48a.78.78,0,0,0-.63-.6l-18.76-4.26a.78.78,0,0,1,0-1.53l18.49-3.56a.75.75,0,0,0,.57-.57l4.58-18.71a.79.79,0,0,1,1.53,0L289.28,60a.8.8,0,0,0,.58.61l19.33,3.78A.78.78,0,0,1,309.12,65.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1310.54,66l-27.72,5.66a1.08,1.08,0,0,0-.91.91l-4.47,27.63a1.09,1.09,0,0,1-2.15.05l-5.85-27.35a1.08,1.08,0,0,0-.88-.85l-26.34-6a1.09,1.09,0,0,1-.07-2.14l26-5a1.11,1.11,0,0,0,.8-.81l6.43-26.26a1.09,1.09,0,0,1,2.13,0l5.21,25.79a1.09,1.09,0,0,0,.81.85l27.13,5.32A1.09,1.09,0,0,1,1310.54,66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057.78,228.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0l2.71,13.46a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,1057.78,228.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.78,178.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0L125.24,174a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,139.78,178.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1454.78,119.31l-14.47,3a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0l2.71,13.46a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,1454.78,119.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057.11,39.89l-17.17,3.51a.68.68,0,0,0-.57.56l-2.76,17.12a.68.68,0,0,1-1.34,0l-3.62-17a.68.68,0,0,0-.55-.52l-16.32-3.71a.67.67,0,0,1,0-1.32l16.09-3.1a.67.67,0,0,0,.49-.5l4-16.27a.68.68,0,0,1,1.32,0l3.22,16a.69.69,0,0,0,.51.52l16.81,3.29A.68.68,0,0,1,1057.11,39.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M584.74,54.4l-17,3.47a.67.67,0,0,0-.56.56l-2.74,17a.67.67,0,0,1-1.32,0l-3.59-16.8a.67.67,0,0,0-.55-.52l-16.17-3.68a.67.67,0,0,1,0-1.31l15.94-3.07a.65.65,0,0,0,.49-.49l4-16.13a.67.67,0,0,1,1.31,0l3.2,15.83a.65.65,0,0,0,.5.52l16.66,3.27A.67.67,0,0,1,584.74,54.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 404.45,
    y: 149.69,
    width: 16.13,
    height: 64.95,
    rx: 5.73
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 383,
    y: 160.1,
    width: 16.13,
    height: 44.12,
    rx: 5.73
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.38,141.09h-4.67a5.74,5.74,0,0,0-5.73,5.73V174.1H442V146.82a5.74,5.74,0,0,0-5.73-5.73h-4.67a5.74,5.74,0,0,0-5.73,5.73v70.69a5.73,5.73,0,0,0,5.73,5.72h4.67a5.73,5.73,0,0,0,5.73-5.72V190.23h63v27.28a5.73,5.73,0,0,0,5.73,5.72h4.67a5.73,5.73,0,0,0,5.73-5.72V146.82A5.74,5.74,0,0,0,515.38,141.09Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 526.43,
    y: 149.69,
    width: 16.13,
    height: 64.95,
    rx: 5.73
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 547.87,
    y: 160.1,
    width: 16.13,
    height: 44.12,
    rx: 5.73
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.92,246.35A91.36,91.36,0,1,0,654.51,155,91.38,91.38,0,0,0,745.92,246.35Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.92,248.15A93.16,93.16,0,1,1,839.13,155,93.29,93.29,0,0,1,745.92,248.15Zm0-182.71A89.56,89.56,0,1,0,835.52,155,89.69,89.69,0,0,0,745.92,65.44Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "846.64 80.23 823.47 78.68 821.57 55.16 854.85 21.89 856.58 45.23 879.92 46.95 846.64 80.23"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M847.33,82.09,821.8,80.37l-2.09-25.89,36.65-36.65,1.9,25.71L884,45.45ZM825.14,77l20.8,1.4,29.92-29.92-21-1.55-1.56-21L823.43,55.85Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.92,227.3A72.31,72.31,0,1,0,673.57,155,72.33,72.33,0,0,0,745.92,227.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.92,205.39A50.4,50.4,0,1,0,695.49,155,50.4,50.4,0,0,0,745.92,205.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.92,207.19A52.2,52.2,0,1,1,798.15,155,52.27,52.27,0,0,1,745.92,207.19Zm0-100.79A48.6,48.6,0,1,0,794.54,155,48.67,48.67,0,0,0,745.92,106.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M745.92,180.25A25.26,25.26,0,1,0,720.64,155,25.25,25.25,0,0,0,745.92,180.25Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.92,182.06A27.07,27.07,0,1,1,773,155,27.1,27.1,0,0,1,745.92,182.06Zm0-50.52A23.46,23.46,0,1,0,769.39,155,23.49,23.49,0,0,0,745.92,131.54Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 746.5,
    y1: 154.47,
    x2: 855.86,
    y2: 45.12
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M746.5,156.28a1.81,1.81,0,0,1-1.27-3.08L854.58,43.84a1.8,1.8,0,1,1,2.55,2.55L747.78,155.75A1.84,1.84,0,0,1,746.5,156.28Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 885.35,
    y: 159.51,
    width: 257,
    height: 34,
    rx: 17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 894.35,
    y: 165.01,
    width: 195,
    height: 23,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1167.43 192.46)"
  }, "75%")), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M889.59,116.69a13.31,13.31,0,0,1,18.23,0,13.62,13.62,0,0,1,0,18.41,13.31,13.31,0,0,1-18.23,0,13.65,13.65,0,0,1,0-18.41Zm5.3,13.53a5.13,5.13,0,0,0,7.61,0,6.95,6.95,0,0,0,0-8.65,5.11,5.11,0,0,0-7.61,0,7,7,0,0,0,0,8.65Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M927.25,113.64a10.59,10.59,0,0,1,6.68,2,6.19,6.19,0,0,1,2.56,5.13,6.71,6.71,0,0,1-2,4.76,6.6,6.6,0,0,1,2.66,5.35,6.38,6.38,0,0,1-2.61,5.26,10.79,10.79,0,0,1-6.81,2H915.31v-24.5Zm-4.55,6.2v3h4.48a2.13,2.13,0,0,0,1.4-.43,1.35,1.35,0,0,0,.52-1.07,1.29,1.29,0,0,0-.52-1,2.18,2.18,0,0,0-1.4-.42Zm0,8.78v3.29h5a2.28,2.28,0,0,0,1.49-.45,1.52,1.52,0,0,0,.54-1.23,1.43,1.43,0,0,0-.56-1.13,2.2,2.2,0,0,0-1.47-.48Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M938.9,131.35a6.83,6.83,0,0,0,2.84.56q3.46,0,3.46-3.36V113.64h7.42v16.07a8.47,8.47,0,0,1-2.69,6.51,10,10,0,0,1-7,2.49,7,7,0,0,1-4-.81Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M957.21,113.64h18.9v6.2H964.59v2.9h9.91v6h-9.91v3.15h11.87v6.23H957.21Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M994.1,119.84v18.3h-7.39v-18.3h-7.38v-6.2h22.15v6.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1005,113.64h7.38v24.5H1005Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1015.59,113.64h8l5.39,15,5.28-15h8l-10,24.5h-6.62Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1046.88,116.69a13.31,13.31,0,0,1,18.23,0,13.65,13.65,0,0,1,0,18.41,13.31,13.31,0,0,1-18.23,0,13.65,13.65,0,0,1,0-18.41Zm5.3,13.53a5.13,5.13,0,0,0,7.61,0,6.95,6.95,0,0,0,0-8.65,5.11,5.11,0,0,0-7.61,0,7,7,0,0,0,0,8.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj75);
export default __webpack_public_path__ + "static/media/Obj_75.93f5b10565810edcd8632561e301bc7b.svg";
export { ForwardRef as ReactComponent };